<form>
  <div class="padding-all--small" style="height: 38px;" fxLayout="row" fxLayoutAlign="space-around center" >
    <input autocomplete="off" matInput type="text" [formControl]="searchInputText"
            (keydown)="$event.stopPropagation()" placeholder="Enter to search text...">
  </div>
</form>

